import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import $ from 'jquery';
import Pagination from "react-js-pagination";
class ManageErFilter extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            search: '',
            message: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            filter_list: [],
            loading: 1
        };
        this.searchChange = this.searchChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    rawjsonparse(findresponse, flg) {
        return findresponse;
    }
    
    searchChange(event) {
        var obj = this;
        this.setState({ search: event.target.value, activePage: 1 });
        //Delaying the function execute
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(function () {
            //Execute the function code here...
            obj.ManageFilterdetails();
        }, 500);
    }

    deltefilter(filterid) {
        if (window.confirm('Are you sure delete this filter')) {
            fetch(this.state.apiUrl + '/ErRest/DeleteFilterList/id/' + filterid + '/userAuthKey/' + this.state.userAuthKey)
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    if (findresponse.code == 200) {
                        this.ManageFilterdetails();
                    } else {
                        this.setState({ message: findresponse.msg })
                    }
                })
        }
    }

    defaultSelete(filterid) {
        fetch(this.state.apiUrl + '/ErRest/ChangeDefaultValue/id/' + filterid + '/userAuthKey/' + this.state.userAuthKey + '/userid/' + this.state.userId)
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.ManageFilterdetails();
                } else {
                    this.setState({ message: findresponse.msg })
                }
            })
    }

    handlePageChange(pageNumber = 1) {
        var totalPages = Math.ceil(this.state.item_count / 20);
        if (this.state.activePage != pageNumber) {
            $(document).ready(function () {
                $('.pages').addClass('disabled');
            });
            this.setState({ activePage: pageNumber, setPage: 'no' });
            fetch(this.state.apiUrl + '/ErRest/FilterList/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
            .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    $(document).ready(function () {
                        $('.pages').removeClass('disabled');
                        if (pageNumber == 1) {
                            $('.first_page').addClass('disabled');
                            $('.prev_page').addClass('disabled');
                        }
                        if (pageNumber == totalPages) {
                            $('.next_page').addClass('disabled');
                            $('.last_page').addClass('disabled');
                        }
                    });
                    this.setState({
                        filter_list: findresponse.filter_list,
                        offset: findresponse.offset,
                        off_count: findresponse.off_count,
                        setPage: 'yes'
                    })
                })
        }
    }

    ManageFilterdetails(page = 1) {
        fetch(this.state.apiUrl + '/ErRest/FilterList/page/' + page + '/userAuthKey/' + this.state.userAuthKey + "/userid/" + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.rawjsonparse(responseJson, 1);
                this.setState({
                    loading: 0,
                    filter_list: responseJson.filter_list,
                    item_count: responseJson.item_count,
                    offset: responseJson.offset,
                    off_count: responseJson.off_count,
                    setPage: 'yes'
                })
            })
    }

    componentDidMount() {
        document.title = "Intranet | Manage Filter";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.ManageFilterdetails();
    }

    getFilterDetails() {
        if (this.state.loading) {
            return (
                <div>
                    <div class="loader-new"></div>
                </div>
            )
        } else {
            return (
                <div class="tickets">
                    <ul class="tickets_head">
                        <li class="intra_col_33 text-center">Filter Name</li>
                        <li class="intra_col_33 text-center">Set As Default</li>
                        <li class="intra_col_33 text-center">Action</li>

                    </ul>
                    <ul class="tickets_number" >
                        <li class="intra_col_33 text-center">All</li>
                        <li class="intra_col_33 manage_ticket text-center">
                            <label>
                                <input type="radio" name="set_deafult" value="0" onClick={() => this.defaultSelete(0)} checked={0 == 0} />
                                <span></span>
                            </label>
                        </li>
                    </ul>
                    {
                        this.state.filter_list.map((filter, key) =>
                            <ul class="tickets_number" >
                                <li class="intra_col_33 text-center">{filter.name}</li>
                                <li class="intra_col_33 manage_ticket text-center">
                                    <label>
                                        <input type="radio" id="set_deafult" name="set_deafult" value={filter.id} onClick={() => this.defaultSelete(filter.id)} checked={filter.is_default == 1} />
                                        <span></span>
                                    </label>
                                </li>
                                <li class="intra_col_33 text-center">{filter.is_default != 1 ? <div className="details_des_manage_filter"><span class="color-red" onClick={() => this.deltefilter(filter.id)} ><i class="fa fa-trash"></i></span></div> : ''}</li>
                            </ul>
                        )
                    }
                    {this.state.item_count > 0 ? <div class="pagination-muvi">
                        <Pagination
                            itemClass={'pages'}
                            itemClassFirst={'first_page'}
                            itemClassPrev={'prev_page'}
                            itemClassNext={'next_page'}
                            itemClassLast={'last_page'}
                            activePage={this.state.activePage}
                            itemsCountPerPage={20}
                            totalItemsCount={this.state.item_count}
                            pageRangeDisplayed={5}
                            onChange={this.state.setPage == 'yes' ? this.handlePageChange : ''}
                        />
                        <div style={{ color: "#333" }}>
                            {(this.state.offset + 1) + ' - ' + (this.state.offset + this.state.off_count)} of {this.state.item_count}
                </div>
                    </div> : <div className="text-center" style={{ color: "#333" }}></div>}
                </div>
            )
        }
    }

    goBack() {
        window.location.href = '/er';
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div >
                <Header brecum_name="Support" brecum_page="Manage Filter" />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob er_ids">
                            <div class="er_id">
                            <HeaderMob page_name="Manage Filter" />
                        </div>
                            <div class="react_auto">
                            <div class="searchTicket emp_dept">
                                <input type="text" class="form-control" name="search" id="search" placeholder="Search Filter Name" onChange={this.searchChange} />
                                <button type="submit"><i class="fa fa-search"></i></button>
                            </div>
                        </div>
                        </div>
                        {this.getFilterDetails()}
                        <div className="form-section ckeditor">
                            <button type="buttom" className="btn btn-blue mob-btn" onClick={() => this.goBack()}>Back</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default ManageErFilter;


// WEBPACK FOOTER //
// ./src/components/er/ManageErFilter.js